import React, {useContext} from "react";
import {useHistory} from "react-router";

import {Button, Typography} from "@material-ui/core";
import Box from "@material-ui/core/Box";

import {BrandContext} from "../../../contexts/BrandContext";
import {ProfileContext} from "../../../contexts/ProfileContext";




export default function GhostHeader(){


    const profile = useContext(ProfileContext);
    const brandContext = useContext(BrandContext);
    const ghostMode = (profile.staffMode && profile.ghostContact);
    // console.log(profile);
    const history = useHistory();
    if(ghostMode){
        if(!brandContext.isLoading) {
            return (
                <Box className="ghostHeader" >
                    <Typography variant="Body2">{brandContext.textContent.bookingFor} {profile.ghostContact.firstName} {profile.ghostContact.lastName} ({profile.ghostContact.email})</Typography>
                    <Button
                        className="releaseButton"
                        size="small"
                        sx={{display:'inline'}}
                        variant="outlined"
                        onClick={()=>{
                            profile.releaseGhost();
                            history.push('/app');
                        }}
                    >
                        Choose Another
                    </Button>
                </Box>
            );
        }
    }
    return '';

}